module.exports = __webpack_public_path__ + "img/logo_yyw_w@2x.8f5d3388.png";